// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"143":"5a8eb341","379":"b2acb464","535":"c65af5ce","972":"5a8eb341"}[chunkId] + ".chunk.css";
};